import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import FieldSet from 'flarum/common/components/FieldSet';
import Switch from 'flarum/common/components/Switch';
import { PREFERENCE_KEY, setThemeLargeClass } from './applyThemeLargeClass';
const SETTINGS_PAGE = 'flarum/forum/components/SettingsPage';

/**
 * Adds a "Afficher le forum en pleine largeur" Switch to the user's own
 * settings page - same pattern as champis-users' addProfileSettings.js
 * (extend `settingsItems` to inject a new FieldSet) and core's own
 * discloseOnline/hapticFeedback Switches (autosave on change via
 * User.savePreferences(), one key at a time).
 */
export default function addThemeLargeSetting() {
  extend(SETTINGS_PAGE, 'oninit', function () {
    this.champisThemeLargeLoading = false;
  });
  extend(SETTINGS_PAGE, 'settingsItems', function (items) {
    items.add('champisThemeLarge', m(FieldSet, {
      className: "Settings-champisThemeLarge FieldSet--min",
      label: app.translator.trans('champis-theme-large.forum.settings.heading')
    }, m(Switch, {
      state: Boolean(this.user.preferences()?.[PREFERENCE_KEY]),
      loading: this.champisThemeLargeLoading,
      onchange: value => {
        this.champisThemeLargeLoading = true;

        // Applied straight away rather than only after the request
        // resolves - a layout toggle should feel instant, and there's
        // nothing to roll back visually if the save fails (the Switch
        // itself already reflects the optimistic value).
        setThemeLargeClass(value);
        this.user.savePreferences({
          [PREFERENCE_KEY]: value
        }).then(() => {
          this.champisThemeLargeLoading = false;
          m.redraw();
        });
      }
    }, app.translator.trans('champis-theme-large.forum.settings.label'), m("span", {
      className: "helpText"
    }, app.translator.trans('champis-theme-large.forum.settings.help')))), -60);
  });
}